// Inline "Review draft" card rendered in the conversation stream when
// the `outreach_draft_ready` SSE event fires. Deliberately tiny — just
// enough surface for the user to spot that a draft is ready and open
// the full review overlay. Explicitly does NOT contain "Send" or
// "Deliver" buttons.

export default function OutreachDraftCard({ draft, onReview }) {
  if (!draft || !draft.draft_id) return null;
  const score = typeof draft.match_score === "number" ? draft.match_score : null;
  const buyer = draft.acquirer_name || "köparen";
  const status = draft.status || "draft";
  return (
    <div className="qai-outreach-card" role="group" aria-label="Outreach-utkast">
      <div className="qai-outreach-card-head">
        <span className="qai-outreach-tag">Utkast förberett</span>
        {score !== null && (
          <span className="qai-outreach-score">{score}/100</span>
        )}
      </div>
      <div className="qai-outreach-card-body">
        <div className="qai-outreach-buyer">{buyer}</div>
        {draft.subject && (
          <div className="qai-outreach-subject" title={draft.subject}>
            {draft.subject}
          </div>
        )}
      </div>
      <div className="qai-outreach-card-actions">
        <button
          type="button"
          className="qai-outreach-review-btn"
          onClick={() => onReview?.(draft.draft_id)}
        >
          Granska utkast
        </button>
        <span className="qai-outreach-status-chip" data-status={status}>
          {statusLabel(status)}
        </span>
      </div>
      <div className="qai-outreach-card-note">
        Godkännande förbereder utkastet för framtida leverans. Inget meddelande skickas.
      </div>
    </div>
  );
}

function statusLabel(s) {
  switch (s) {
    case "draft":     return "Utkast";
    case "approved":  return "Godkänt";
    case "rejected":  return "Avvisat";
    case "sending":   return "Skickar…";
    case "sent":      return "Skickat";
    case "failed":    return "Misslyckades";
    default:          return s;
  }
}
